import {RawMessage} from '../../RawMessagesStore';
import {IMCPeerPreview} from '../../../api/proto';

export default function getReactionPeers(rawMessages: RawMessage[]): IMCPeerPreview[] {
  const peerMap = new Map<string, IMCPeerPreview>();

  for (let i = 0; i < rawMessages.length; i++) {
    const msg = rawMessages[i];
    const reactions = msg.reactions;
    const details = reactions?.details;
    if (!details || details.length === 0) continue;

    for (let j = 0; j < details.length; j++) {
      const peer = details[j].peer;
      const id = peer?.id;
      if (peer && id) {
        peerMap.set(id.toString(), peer);
      }
    }
  }

  return Array.from(peerMap.values());
}
